import React from "react";
import "./ConsumeFeedControls.css";

interface ConsumeFeedControlsProps {
  showStockOverlay: boolean;
  onToggleStockOverlay: () => void;
}

const ConsumeFeedControls: React.FC<ConsumeFeedControlsProps> = ({
  showStockOverlay,
  onToggleStockOverlay,
}) => {
  return (
    <div className={`camera-feed__controls ${showStockOverlay ? 'is-hidden' : ''}`}>
      <button
        type="button"
        onClick={onToggleStockOverlay}
        className="camera-feed__stock-button"
      >
        {showStockOverlay ? "Hide Stock" : "Show Stock"}
      </button>
    </div>
  );
};

export default ConsumeFeedControls; 